export enum ExpenseCategoryEnum {
  COMISSAO = "COMISSAO"
}

export const ExpenseCategoryLabel = new Map<ExpenseCategoryEnum, string>([[ExpenseCategoryEnum.COMISSAO, "Comissão"]]);



// WEBPACK FOOTER //
// ./src/services/Enum/ExpenseCategoryEnum.ts